export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/vector_tracing.a382702.svg";